import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getTestGroupDetail, createTestGroup, updateTestGroup } from '../api/testGroupApi'
import { appToast } from '../../../../components/AppToast'

export function useTestGroupEntryScreen() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const groupId = searchParams.get('id')

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    status: 'Active',
    archive: false,
  })

  const [isLoading, setIsLoading] = useState(!!groupId)
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!groupId) {
      setIsLoading(false)
      return
    }

    let active = true
    setIsLoading(true)
    setError('')

    getTestGroupDetail(groupId)
      .then((data) => {
        if (!active) return
        setFormData(data)
        setFormData({
          name: data?.name || '',
          archive: Boolean(data?.archive),
        })
      })
      .catch((err) => {
        if (!active) return
        setError(err?.message || 'Failed to load test group')
      })
      .finally(() => {
        if (active) setIsLoading(false)
      })

    return () => {
      active = false
    }
  }, [groupId])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const validateForm = () => {
    if (!formData.name?.trim()) {
      setError('Group Name is required')
      setError('Test Group Name is required.')
      return false
    }
    return true
  }

  const handleSave = async () => {
    setError('')
    if (!validateForm()) return

    setIsSaving(true)
    try {
      const payload = {
        name: formData.name.trim(),
        archive: Boolean(formData.archive),
      }
      if (groupId) {
        await updateTestGroup(groupId, payload)
        appToast.success('Test Group updated successfully.')
      } else {
        await createTestGroup(payload)
        appToast.success('Test Group created successfully.')
      }
      navigate('/education/tests/groups')
      return
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || 'Failed to save test group'
      setError(msg)
      appToast.error(msg)
    } finally {
      setIsSaving(false)
    }
  }

  return {
    state: {
      groupId,
      formData,
      isLoading,
      isSaving,
      error,
      groupId,
    },
    actions: {
      handleChange,
      handleSave,
      setFormData,
      setError,
    },
  }
}
